import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "services/redux/index";

const store = configureStore({
    reducer: rootReducer
});

export default store;
